import React from 'react'
import { type StepProps } from '@adsk/napi-shared'
import { HeaderComponent, FooterComponent, BodyComponent } from './components'

export const PROFILE_PICTURE_STEP_IDX = 1

const ProfilePictureStep = (): StepProps => {
	return {
		size: 'large',
		root: {
			props: {
				style: {
					height: 'auto',
				},
			},
		},
		header: {
			content: <HeaderComponent />,
			props: {
				disableBorder: true,
			},
		},
		body: {
			content: <BodyComponent />,
			props: {
				style: {
					padding: 0,
				},
			},
		},
		footer: {
			content: <FooterComponent />,
		},
	}
}

export default ProfilePictureStep
